// extracted by mini-css-extract-plugin
export default {"container":"InfoCard_container__+L0RQ","tags":"InfoCard_tags__CZ5Aj"};